export function showModal(message, title = 'Сообщение') {
    const modal = document.getElementById('app-modal');
    if (!modal) {
        alert(title + '\n\n' + message);
        return;
    }

    const titleEl = modal.querySelector('#app-modal-title');
    const bodyEl = modal.querySelector('#app-modal-message');
    titleEl && (titleEl.innerText = title);

    if (typeof message === 'string') {
        bodyEl.innerText = message;
    } else if (message instanceof HTMLElement) {
        bodyEl.innerHTML = '';
        bodyEl.appendChild(message);
    } else {
        bodyEl.innerText = JSON.stringify(message);
    }

    if (!modal.open) {
        modal.showModal(); // открываем нативный диалог
    }
}

export function hideModal() {
    const modal = document.getElementById('app-modal');
    modal && modal.close(); // закрываем нативный диалог
}

// auto bind close buttons
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('app-modal');
    if (!modal) return;

    const close = modal.querySelector('#app-modal-close');
    const ok = modal.querySelector('#app-modal-ok');

    [close, ok].forEach(el => el && el.addEventListener('click', () => modal.close()));
});
